export default "__VITE_ASSET__Y7rRRzds__"